import { render } from "./AlertComponent.vue?vue&type=template&id=9201e614"
import script from "./AlertComponent.vue?vue&type=script&lang=js"
export * from "./AlertComponent.vue?vue&type=script&lang=js"

import "./AlertComponent.vue?vue&type=style&index=0&id=9201e614&lang=less"

import exportComponent from "/Users/yulian/DEVELOPMENT/g2-rtf-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__